import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { API_SETTINGS } from '../api-services/API_SETTINGS';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

const apiUrl = API_SETTINGS.API_URL + 'File';

@Injectable({
  providedIn: 'root'
})
export class FileSizeService {

  constructor(private http: HttpClient) {
  
  }

  getFileSize(blobUrl): Promise<number> {
    return new Promise<number>((resolve) => {
      this.http.post<number>(apiUrl + "/GetFileSize", '"' + blobUrl + '"', httpOptions).subscribe(fileSize => {
        let sizeInGB: number = ((fileSize / 1024) / 1024) / 1024;
        resolve(sizeInGB);
      });
    });
    /* return new Promise<number>((resolve, reject) => {
      fetch(url).then(function (response) {
        return response.blob();
      }).then(function (blob) {
        let sizeInGB: number = ((blob.size / 1024) / 1024) / 1024;
        resolve(sizeInGB);
      }).catch(function(error) {
        reject('There has been a problem with your fetch operation: ' + error.message);
      });
    }); */
  }

  getFileSizeWithMetric(asset: any) {
    let value: string = '';
    if (Math.trunc(asset.fileSize) > 0) {
      value = '' + parseFloat(asset.fileSize.toFixed(2)) + ' GB';
    } else if (Math.trunc(asset.fileSize * 1000) > 0) {
      value = '' + parseFloat((asset.fileSize * 1000).toFixed(2)) + ' MB';
    } else {
      value = '' + parseFloat((asset.fileSize * 1000000).toFixed(2)) + ' KB';
    }

    return value;
  }

  getProjectSizeWithMetric(size: any) {
    let value: string = '';
    if (Math.trunc(size) > 0) {
      value = '' + parseFloat(size.toFixed(2)) + ' GB';
    } else if (Math.trunc(size * 1000) > 0) {
      value = '' + parseFloat((size * 1000).toFixed(2)) + ' MB';
    } else {
      value = '' + parseFloat((size * 1000000).toFixed(2)) + ' KB';
    }

    return value;
  }
}